import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  ChangeDetectorRef,
  inject,
  OnInit,
  OnChanges,
  OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from '../services/user.service';

@Directive({
  selector: '[hasPermission]',
  standalone: true,
})
export class HasPermissionDirective implements OnInit, OnChanges, OnDestroy {
  @Input('hasPermission') permissions: string | string[] = '';

  private templateRef = inject(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);
  private userService = inject(UserService);
  private cdr = inject(ChangeDetectorRef);
  private rendered = false;
  private userSub?: Subscription;

  ngOnInit(): void {
    this.updateView();
    this.userSub = this.userService.userUpdated$?.subscribe(() => {
      this.updateView();
      this.cdr.markForCheck();
    });
  }

  ngOnChanges(): void {
    this.updateView();
  }

  ngOnDestroy(): void {
    this.userSub?.unsubscribe();
  }

  private updateView(): void {
    const hasAccess = this.checkPermission();

    if (hasAccess && !this.rendered) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.rendered = true;
    } else if (!hasAccess && this.rendered) {
      this.viewContainer.clear();
      this.rendered = false;
    }
  }

  private checkPermission(): boolean {
    const user = this.userService.currentUser;
    if (!user) return false;

    const required = Array.isArray(this.permissions) ? this.permissions : [this.permissions];
    return user.hasAnyPermission(required);
  }
}
